import gsap from 'gsap';

window.LoaderModule = (function(w, $) {
    const settings = {
      $body: $('body'),
      $loader: $('.loader'),
      $loaderContent: $('.loader').find('.loader-content'),
      $starWrapper: $('.loader').find('.star-wrapper'),
      $mask: $('.loader').find('.mask'),
      $x: $('.loader').find('.x'),
      $city: $('.loader').find('.city')
    };

    // initialize Module
    const init = () => {
      const _s = settings;

      if($('.loader').length) {
        console.log('initialize Loader Module');

        const isCity = false; // _s.$body.hasClass('single-city')

        playLoader(_s, isCity);


        window.addEventListener('load', function () {
            removeLoader(_s);
        })

      } else {
        _s.$body.removeClass('no-scroll');
      }
    };

    const playLoader = (_s, isCity) => {
      const { $starWrapper, $mask, $x, $city } = _s;

      const timeline = gsap .timeline();

      if(isCity) {
        timeline
          .to($mask, { scale: 0, duration: 0.8 }, 0.2)
          .to($starWrapper, { rotation: 90, left: 0, translateX: '-50%', duration: 0.6 }, 0.9)
          .to($x, { opacity: 1, duration: 0.2 }, 1.3)
          .to($city, { opacity: 1, duration: 0.2 }, 1.3);
      } else {
        timeline
          .to($mask, { scale: 0, duration: 1 }, 0.2)
          .to($starWrapper, { rotation: 90, duration: 0.6 })
          .to($mask, { scale: 1, duration: 1 })
          .to($mask, { scale: 0, duration: 1, delay: 0.4 })
          .to($starWrapper, { rotation: '+=90', duration: 0.6 });
      }

      // Removes loader once animations are complete
      setTimeout(function() {
        removeLoader(_s);
      }, (timeline.endTime() * 1000) + (isCity ? 300 : 0));
    }

    const removeLoader = (_s) => {
      _s.$body.removeClass('no-scroll');
      _s.$loader.fadeOut();
    }

    return { init };
})(window, jQuery)
